import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// antd's own base stylesheet — must load BEFORE theme.css so our overrides
// layer on top correctly. Without this, antd's structural CSS never loads.
import "antd/dist/antd.css";
import "./styles/theme.css";
import apiPath from "./constants/apiPath";
import { bootstrapTeams, openedInTeams } from "./helper/teams";

// Pages a Teams alert is allowed to open (see helper/teams.js).
const TEAMS_PAGES = ["/", "/attendance", "/leave", "/wfh", "/holidays", "/reimbursements", "/overtime"];

async function start() {
  const rootEl = document.getElementById("root");
  // Opened as a Teams tab: sign in with Microsoft and open the linked page first.
  if (openedInTeams()) {
    rootEl.innerHTML = '<div style="font-family:Inter,system-ui,sans-serif;color:#6B7280;display:flex;align-items:center;justify-content:center;height:100vh">Signing you in…</div>';
    await bootstrapTeams({
      tokenKey: "i_ems_employee_token",
      profileKey: "i_ems_employee_profile",
      ssoUrl: apiPath.baseURL + apiPath.teamsSso,
      allowedPaths: TEAMS_PAGES,
    });
  }
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
start();

// Register the service worker so this app can receive Web Push notifications
// even when the tab/app is closed (Chrome/Firefox/Edge desktop + Android Chrome).
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js");
  });
}
